/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useState } from 'react';
import PropTypes from 'prop-types';

// @mui material components
import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';

// Material Dashboard 2 PRO React components
import MDInput from 'components/MDInput';
import MDBox from 'components/MDBox';

function FormQuantityAdd({ parent, callback }) {
  const [quantity, setQuantity] = useState('');
  const [insert, setInsert] = useState(false);

  const send = () => {
    if (quantity <= 0) return;
    callback(parent, quantity);
    setQuantity('');
    setInsert(true);
  };

  return insert ? (
    <code className='color-success'>เพิ่มรายการแล้ว</code>
  ) : (
    <MDBox
      noValidate
      component='form'
      role='form'
      onSubmit={(e) => {
        e.preventDefault();
        send();
      }}
    >
      <MDInput
        value={quantity}
        onChange={(e) => setQuantity(e.target.value)}
        onFocus={(e) => e.target.select()}
        variant='standard'
        type='number'
        fullWidth
        InputProps={{
          inputProps: {
            maxLength: 20,
            autoComplete: 'off',
            className: 'text-right',
            placeholder: '0',
          },
          endAdornment: (
            <IconButton onClick={send} color='error'>
              <Icon>add_circle</Icon>
            </IconButton>
          ),
        }}
      />
    </MDBox>
  );
}

FormQuantityAdd.propTypes = {
  parent: PropTypes.shape({
    id: PropTypes.string.isRequired,
    unit_id: PropTypes.string.isRequired,
    quantity: PropTypes.string.isRequired,
  }).isRequired,
  callback: PropTypes.func.isRequired,
};

export default FormQuantityAdd;
